"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var AuthCard = function (props) {
    var children = props.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "mt-4 mx-auto w-full sm:max-w-md", children: (0, jsx_runtime_1.jsx)("div", { className: "bg-white py-6 px-5 sm:px-10 shadow sm:rounded-lg", children: children }) }));
};
exports.AuthCard = AuthCard;
